import { useEffect, useState } from "react";
import { usePayment, useAuth } from "src/hooks/context";
import {
    StyledBankItem,
    StyledBankList,
    StyledBankLogo,
    StyledBankName,
    StyledBankWrapper,
    StyledCardButton,
    StyledCardEmoji,
    StyledHeaderWrapper,
    StyledLegalLink,
    StyledLegalText,
    StyledLogoWrapper,
} from "./BankList.styled";
import { localSources, ibanLocalSource } from "./localSources";
import { Bank } from "src/context/Payment/types";

import CardEmoji from "src/assets/cardEmoji.png";
import Tab from "@joinTrilo/ui/atoms/Tab";

export type TBankInfo = {
    id?: string;
    bankName?: string;
    logo?: string;
};

export const BankList = () => {
    const { paymentState, updatePaymentState } = usePayment();
    const { authState } = useAuth();

    const intercomConfig = authState.intercomConfig
        ? JSON.parse(authState.intercomConfig)
        : null;
    const intercomEvent = "bank-not-found";

    // States
    const [banks, setBanks] = useState<Bank[]>([]);
    // const [banks] = useState<Bank[]>(localSources);
    useEffect(() => {
        if (banks.length) return;

        if (paymentState.recipient?.features?.hasIBAN) {
            setBanks(ibanLocalSource);
        } else {
            setBanks(localSources);
        }
    }, [banks, setBanks, paymentState.recipient?.features?.hasIBAN]);

    // Handle input changes
    const handleBankSelect = (bank: Bank) => {
        updatePaymentState({ paymentMethod: bank, paymentUrl: null });
    };

    const hasCards = paymentState.recipient?.features?.hasCards;

    const handleBankNotFound = () => {
        if (hasCards) {
            updatePaymentState({
                paymentMethod: {
                    id: "stripe",
                    name: "Cards",
                    logo: "https://d1nhio0ox7pgb.cloudfront.net/_img/g_collection_png/standard/512x512/credit_cards.png",
                },
                paymentUrl: null,
            });
        } else if (intercomConfig) {
            console.log({ intercomConfig });
            // @ts-ignore
            window?.Intercom("boot", intercomConfig);
            // @ts-ignore
            window?.Intercom("trackEvent", intercomEvent);
            // @ts-ignore
            window?.Intercom("show");
        }
    };

    const [, setNotFound] = useState(false);

    return (
        <>
            <StyledBankWrapper>
                <StyledHeaderWrapper>
                    <Tab
                        tabs={[
                            {
                                key: "selectYourAccount",
                                text: "🏦 Select your account",
                            },
                        ]}
                    />
                    {hasCards && (
                        <StyledCardButton
                            onClick={handleBankNotFound}
                            hasStripe={hasCards}
                        >
                            <StyledCardEmoji src={CardEmoji} />
                        </StyledCardButton>
                    )}
                </StyledHeaderWrapper>
                <StyledBankList>
                    {banks.map((bank) => (
                        <StyledBankItem
                            key={bank.id}
                            onClick={() => {
                                handleBankSelect(bank);
                            }}
                        >
                            <StyledLogoWrapper>
                                <StyledBankLogo
                                    src={bank.logo}
                                    alt={bank.name}
                                />
                            </StyledLogoWrapper>
                            <StyledBankName>{bank.name}</StyledBankName>
                        </StyledBankItem>
                    ))}
                    <StyledBankItem
                        onClick={() => {
                            handleBankNotFound();
                            setNotFound(true);
                        }}
                    >
                        <StyledLogoWrapper>
                            <StyledBankLogo
                                src={
                                    hasCards
                                        ? CardEmoji
                                        : "https://uploads-ssl.webflow.com/5f32b7eea3b2c90751809aca/62bd60e5f7647998b2d3709d_Trilo%20Logo.svg"
                                }
                                alt={
                                    hasCards
                                        ? "Pay by card"
                                        : "Can’t find your bank?"
                                }
                            />
                        </StyledLogoWrapper>
                        <StyledBankName>
                            {hasCards ? "Pay by card" : "Can't find your bank?"}
                        </StyledBankName>
                    </StyledBankItem>
                </StyledBankList>
            </StyledBankWrapper>
            <StyledLegalText>
                By selecting continue, you agree to the Trilo{" "}
                <StyledLegalLink
                    href="https://www.trilo.io/legal"
                    target="_blank"
                    rel="noreferrer"
                >
                    terms and conditions
                </StyledLegalLink>
                , and{" "}
                <StyledLegalLink
                    href="https://www.trilo.io/legal"
                    target="_blank"
                    rel="noreferrer"
                >
                    privacy policy
                </StyledLegalLink>
            </StyledLegalText>
        </>
    );
};

export default BankList;
